var map = {
	"./i2.png": "PPLp",
	"./i2en.png": "cHxH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Qp23";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet ^\.\/i2.*\.png$
// module id = Qp23
// module chunks = 0